export default __webpack_public_path__ + "static/media/header_cover_mobile.3f903bc7.png";